import { render } from "./ActionIcon.vue?vue&type=template&id=bbe3ddb6&scoped=true"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"

import "./ActionIcon.vue?vue&type=style&index=0&id=bbe3ddb6&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe3ddb6"]])

export default __exports__